import controller from './contract-mobile.controller';

export default {
  bindings: {
    onConfirm: '&',
    onPreInfoMobile: '&',
    showPreInfo: '<'
  },
  controller,
  template: require('./contract-mobile.html')
};



// WEBPACK FOOTER //
// src/app/buy/contract-mobile/contract-mobile.component.ts